'use client'

import { cn } from '@/utils/common'
import * as React from 'react'

interface LoadingCircleProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg'
}

export function LoadingCircle({ size = 'md', className, ...props }: LoadingCircleProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-10 w-10'
  }

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-t-transparent',
        sizeClasses[size],
        className
      )}
      style={{
        borderWidth: size === 'lg' ? '3px' : '2px',
        borderColor: '#e5e7eb',
        borderTopColor: 'transparent'
      }}
      {...props}
    />
  )
}
